// Soft two-tone chime for incoming SMS replies. Web Audio only — no asset.
// Browsers block audio before the first user gesture; we fail silently then.
let lastPlay = 0;

export const playReplyChime = () => {
  const now = Date.now();
  if (now - lastPlay < 3000) return; // don't stack chimes on bursts
  lastPlay = now;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const t0 = ctx.currentTime;
    [880, 1318.5].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const start = t0 + i * 0.14;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.09, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.45);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.5);
    });
    setTimeout(() => { try { ctx.close(); } catch { /* noop */ } }, 1500);
  } catch {
    /* audio unavailable/blocked — silent by design */
  }
};
